// extracted by mini-css-extract-plugin
export default {"loclIcon":"LanguageSwitcher_loclIcon__digxB","icon":"LanguageSwitcher_icon__62eF-"};